import { Divider } from "primereact/divider";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import { Description } from "../../../components/Description";
import styles from "../../../components/ListDescriptions/styles.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL, formatarCNPJ } from "../../../utils";
 
export function DevedorUniaoI({ pgfni }: { pgfni: any }) {
  const { t } = useTranslation();
 
 
  const getValor = (item:any) => {
    if(item.VALOR){
      return formatarParaMoedaBRL(Number(item.VALOR.replace(',', '.')));
    }
    return '';
  }
 
  const formartarDocumento = (item:any) => {
    if(item.CNPJ){
      return formatarCNPJ(item.CNPJ);
    }
    return '';
  }
 
  return (
    
    <Panel header={t("devedorUniao")}>
      {pgfni.INFORMACOES_ALERTAS_RESTRICOES && (
        <div>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
              
            <svg width="24" height="24" viewBox="0 0 24 22" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>
                <span style={{paddingLeft: '0.5rem'}}>
                  <b>Informações do Devedor</b>
                </span>
            </div>
          </Divider>
          <div className={styles.wrapper}>
          
            {pgfni.INFORMACOES_ALERTAS_RESTRICOES && pgfni.INFORMACOES_ALERTAS_RESTRICOES.OCORRENCIAS && (
              <div className={styles.gridContainer}>
                {pgfni.INFORMACOES_ALERTAS_RESTRICOES.OCORRENCIAS.map((ocorrencia:any) => (
                  <Description key={ocorrencia.TITULO} label={ocorrencia.TITULO} value={ocorrencia.OBSERVACOES} />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
 
      {pgfni.IDENTIFICACAO_PESSOA_FISICA && (
        <div>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
              
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><rect x="3" y="5" width="6" height="6" rx="1"/><path d="m3 17 2 2 4-4"/><path d="M13 6h8"/><path d="M13 12h8"/><path d="M13 18h8"/></svg>
            <span style={{paddingLeft: '0.5rem'}}>
              <b>Informações cadastrais</b>
            </span>
            </div>
          </Divider>
          <div className={styles.wrapper}>
            <div className={styles.gridContainer}>
              <Description key={'nome'} label={'Nome'} value={pgfni.IDENTIFICACAO_PESSOA_FISICA.NOME } />
              <Description key={'rg'} label={'RG'} value={pgfni.IDENTIFICACAO_PESSOA_FISICA.RG_NUMERO } />
              <Description key={'rgUF'} label={'RG UF'} value={pgfni.IDENTIFICACAO_PESSOA_FISICA.RG_UF } />
              <Description key={'sexo'} label={'Sexo'} value={pgfni.IDENTIFICACAO_PESSOA_FISICA.SEXO } />
              <Description key={'titulo'} label={'Título Eleitor'} value={pgfni.IDENTIFICACAO_PESSOA_FISICA.TITULO_ELEITOR } />
              <Description key={'mae'} label={'Mãe'} value={pgfni.IDENTIFICACAO_PESSOA_FISICA.MAE } />
              <Description key={'nascimento'} label={'Nascimento'} value={pgfni.IDENTIFICACAO_PESSOA_FISICA.NASCIMENTO } />
            </div>
          </div>
        </div>
      )}
 
      {pgfni.PARENTES && pgfni.PARENTES.INFOCONTATOS && (
        <div>
          <br></br>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }} ><circle cx="10" cy="7" r="4"/><path d="M10.3 15H7a4 4 0 0 0-4 4v2"/><circle cx="17" cy="17" r="3"/><path d="m21 21-1.9-1.9"/></svg>
              <span style={{paddingLeft: '0.5rem'}}>
                <b>Parentes</b>
              </span>
            </div>
          </Divider>
          <br></br>
          <DataTable size="small" value={pgfni.PARENTES.INFOCONTATOS} tableStyle={{ minWidth: '50rem' }}>
              <Column field="DOCUMENTO" header={t('documento')}></Column>
              <Column field="NOME" header={t('nome')}></Column>
              <Column field="RELACAO" header={t('relacao')}></Column>
              <Column field="NASCIMENTO" header={t('idade')}></Column>
          </DataTable>
        </div>
      )}
 
      {pgfni.CONTATOS && pgfni.CONTATOS.INFOCONTATOS && (
        <div>
          <br></br>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
            <svg width="24" height="24" viewBox="0 0 24 20" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M15 13a3 3 0 1 0-6 0"/><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"/><circle cx="12" cy="8" r="2"/></svg>
              <span style={{paddingLeft: '0.5rem'}}>
                <b>Contatos</b>
              </span>
            </div>
          </Divider>
          <br></br>
          <DataTable size="small" value={pgfni.CONTATOS.INFOCONTATOS} tableStyle={{ minWidth: '50rem' }}>
              <Column field="DOCUMENTO" header={t('documento')}></Column>
              <Column field="NOME" header={t('nome')}></Column>
              <Column field="CIDADE" header={t('cidade')}></Column>
              <Column field="NASCIMENTO" header={t('idade')}></Column>
          </DataTable>
        </div>
      )}
 
      {pgfni.EMAILS && pgfni.EMAILS.INFOEMAILS && (
        <div>
          <br></br>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
            <svg width="24" height="24" viewBox="0 0 24 20" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
              <span style={{paddingLeft: '0.5rem'}}>
                <b>E-mail</b>
              </span>
            </div>
          </Divider>
          <br></br>
          <DataTable size="small" value={pgfni.EMAILS.INFOEMAILS} tableStyle={{ minWidth: '50rem' }}>
              
              <Column field="ENDERECO" header={t('email')}></Column>
          </DataTable>
        </div>
      )}
 
    {pgfni.SOMENTE_TELEFONE && pgfni.SOMENTE_TELEFONE.DADOS && (
        <div>
          <br></br>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/><path d="M14.05 2a9 9 0 0 1 8 7.94"/><path d="M14.05 6A5 5 0 0 1 18 10"/></svg>
              <span style={{paddingLeft: '0.5rem'}}>
                <b>Telefones</b>
              </span>
            </div>
          </Divider>
          <br></br>
          <DataTable size="small" value={pgfni.SOMENTE_TELEFONE.DADOS} tableStyle={{ minWidth: '50rem' }}>
              
              <Column field="DDD" header={t('ddd')}></Column>
              <Column field="NUM_TELEFONE" header={t('fone')}></Column>
              <Column field="TIPO_TELEFONE" header={t('tipo')}></Column>
          </DataTable>
        </div>
      )}
 
      {pgfni.SOMENTE_ENDERECO && pgfni.SOMENTE_ENDERECO.DADOS && (
        <div>
          <br></br>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z"/><path d="M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2"/><path d="M18 22v-3"/><circle cx="10" cy="10" r="3"/></svg>
              <span style={{paddingLeft: '0.5rem'}}>
                <b>Endereços</b>
              </span>
            </div>
          </Divider>
          <br></br>
          <DataTable size="small" value={pgfni.SOMENTE_ENDERECO.DADOS} tableStyle={{ minWidth: '50rem' }}>
              
              <Column field="ENDERECO" header={t('logradouro')}></Column>
              <Column field="NUMERO" header={t('numero')}></Column>
              <Column field="COMPLEMENTO" header={t('complemento')}></Column>
              <Column field="BAIRRO" header={t('bairro')}></Column>
              <Column field="CEP" header={t('cep')}></Column>
              <Column field="CIDADE" header={t('cidade')}></Column>
              <Column field="UF" header={t('uf')}></Column>
          </DataTable>
        </div>
      )}
 
      {pgfni.PARTICIPACAO_EM_EMPRESAS && pgfni.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS && (
        <div>
          <br></br>
          <Divider align="left">
            <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/></svg>
              <span style={{paddingLeft: '0.5rem'}}>
                <b>Participações em empresa</b>
              </span>
            </div>
          </Divider>
          <br></br>
          <DataTable size="small" value={pgfni.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
              <Column field="RAZAO_SOCIAL" header={t('razaoSocial')}></Column>
              <Column body={formartarDocumento} header={t('cnpj')}></Column>
              <Column field="PARTICIPANTE_CARGO" header={t('cargo')}></Column>
              <Column field="PARTICIPANTE_ENTRADA" header={t('data')}></Column>
          </DataTable>
        </div>
      )}
 
      <br></br>
      <Divider align="left">
        <div style={{color: 'rgb(113, 113, 122)', fontSize: '1.5rem'}}>
          <svg width="28" height="28" viewBox="0 0 24 18" fill="none" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><rect width="20" height="12" x="2" y="6" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></svg>
          <span style={{paddingLeft: '0.5rem'}}>
            <b>Informações da Dívida</b>
          </span>
        </div>
      </Divider>
      <br></br>
      {pgfni.CADIN && pgfni.CADIN.OCORRENCIAS && pgfni.CADIN.OCORRENCIAS.length > 0 ? (
        <div>
         
          <DataTable size="small" value={pgfni.CADIN.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
              <Column field="NATUREZA" header={t('natureza')}></Column>
              <Column field="QUANTIDADE" header={t('quantidade')}></Column>
              <Column field="INSCRICAO" header={t('inscricao')}></Column>
              <Column body={getValor} header={t('valor')}></Column>
          </DataTable>
        </div>
      ):(<p>NENHUMA INFORMAÇÃO ENCONTRADA</p>)}
      
    </Panel>
  );
}